//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { IInstagramUsedHashtag } from '@apis/instagram-hashtags-usage/instagramHashtagsUsageApiModels';
import { groupBy } from '@utils/groupBy';

export const getTrackedAndUsedHashtagLists = (usedHashtags: IInstagramUsedHashtag[]) => {
  const groupedByIsTracked = groupBy(usedHashtags, (hashtag) => {
    return hashtag.isTracked;
  });

  return {
    trackedHashtags: groupedByIsTracked.true || [],
    otherUsedHashtags: groupedByIsTracked.false || [],
  };
};
